import styled from 'styled-components';
import { ModalLayout } from '@clds/modal';

export const NarrowModalLayout = styled(ModalLayout)`
  width: 500px;
  p {
    margin: ${(props) => props.theme.spacing.sm} 0;
  }
`;
